import { useCallback, useState } from 'react';
import useCallbackRef from './useCallbackRef';
import { DownloadBannerStatus } from 'models/Download';
import { DownloadStatusBannerRef } from 'components/DownloadStatusBanner/DownloadStatusBanner.component';

export default function useDownloadBanner() {
  const [downloadStatus, setDownloadStatus] =
    useState<DownloadBannerStatus>(null);

  const [downloadBanner, downloadBannerRef] =
    useCallbackRef<DownloadStatusBannerRef>();

  const showDownloadBanner = useCallback(
    (status: DownloadBannerStatus | null) => {
      setDownloadStatus(status);

      if (status) downloadBanner?.open();
      else downloadBanner?.close();
    },
    [downloadBanner],
  );

  return { downloadStatus, downloadBannerRef, showDownloadBanner };
}
